import _ from '@lodash';
import React, { useState } from 'react';
import { TableCell, Tooltip, IconButton } from '@material-ui/core';
import Timeline from '@material-ui/icons/Timeline';
import ChartPopup from 'app/admin/common/components/ChartPopup';

function MeasurementTimelineButton(props) {
	const [openDialog, setOpenDialog] = useState(false);
	return (
		<TableCell className="text-center" padding="none">
			<Tooltip title="Show Timeline">
				<span>
					<IconButton onClick={e => { setOpenDialog(true); e.preventDefault(); }}>
						<Timeline fontSize="small" />
					</IconButton>
				</span>
			</Tooltip>
			{openDialog && (<ChartPopup item={props.item} onClose={() => setOpenDialog(false)} />)}
		</TableCell>
	);
}

export default MeasurementTimelineButton;
